import { Controller } from "@hotwired/stimulus"
import { syncGateReason } from "../lib/gate_reason"

// Booking question form (#15843): shows the choices list for Multiple choice
// and Dropdown, and the lowest/highest pair for Number, disabling the inputs of
// a hidden section so they never submit. Choice rows are cloned from a
// <template>; an agent's text is only ever an input value, never markup.
const CHOICE_KINDS = ["multiple_choice", "dropdown"]

export default class extends Controller {
  static targets = ["kind", "options", "optionList", "optionTemplate", "addOption", "bounds"]
  static values = { maxOptions: { type: Number, default: 20 } }

  connect() {
    this.sync()
  }

  sync() {
    const kind = this.kindTarget.value
    this.toggle(this.optionsTarget, CHOICE_KINDS.includes(kind))
    this.toggle(this.boundsTarget, kind === "number")
    this.syncAddButton()
  }

  addOption() {
    if (this.rows().length >= this.maxOptionsValue) return

    const row = this.optionTemplateTarget.content.firstElementChild.cloneNode(true)
    this.optionListTarget.append(row)
    row.querySelector("input")?.focus()
    this.syncAddButton()
  }

  removeOption(event) {
    event.currentTarget.closest("[data-option-row]")?.remove()
    this.syncAddButton()
    this.element.dispatchEvent(new Event("input", { bubbles: true }))
  }

  toggle(section, visible) {
    section.hidden = !visible
    section.querySelectorAll("input").forEach((input) => { input.disabled = !visible })
  }

  rows() {
    return [...this.optionListTarget.querySelectorAll("[data-option-row]")]
  }

  // BUTTON-4: at the cap, Add Choice stays visible, disabled, and says why.
  // (While the choices section is hidden the button is hidden with it.)
  syncAddButton() {
    const atMax = this.rows().length >= this.maxOptionsValue
    syncGateReason(this.addOptionTarget, {
      ready: !this.optionsTarget.hidden && !atMax,
      reason: atMax ? `A question can have at most ${this.maxOptionsValue} choices` : "Pick a question type with choices first"
    })
  }
}
